import cssModule from "@vercel/turbopack-next/internal/font/local/cssmodule.module.css?{%22path%22:%22global-error.tsx%22,%22import%22:%22%22,%22arguments%22:[{%22src%22:[{%22path%22:%22../../public/fonts/Roboto-Thin.ttf%22,%22weight%22:%22100%22},{%22path%22:%22../../public/fonts/Roboto-Light.ttf%22,%22weight%22:%22300%22}],%22variable%22:%22--font-roboto%22}],%22variableName%22:%22fontRoboto%22}";
const fontData = {
    className: cssModule.className,
    style: {
        fontFamily: "'fontRoboto', 'fontRoboto Fallback'",
        
    },
};

if (cssModule.variable != null) {
    fontData.variable = cssModule.variable;
}

export default fontData;
